module.exports = "#define GLSLIFY 1\nuniform float progress;\n\nvoid main(){\n\tgl_FragColor=vec4(1.,.95,.48,1.-progress);\n}\n"